// import "jquery";

const $icons = $('.js-menu-toggle');
// const $subnavItems = $('#primary-menu .submenu-content.menu-item-has-children');

function openMenu() {
    console.info('openMenu()');
    $icons.toggleClass('active');
    $('#primary-menu').addClass('active');
    $('#icon-menu-open').attr('aria-expanded', 'true');
    $('#icon-menu-close').attr('aria-hidden', 'false');
}

function closeMenu() {
    console.info('closeMenu()');
    $icons.toggleClass('active');
    $('#primary-menu').removeClass('active');
    $('#icon-menu-open').attr('aria-expanded', 'false');
    $('#icon-menu-close').attr('aria-hidden', 'true');
}

/*
function showChildren(el) {
  console.info('showChildren(el)');
  $subnavItems.removeClass('show');
  $(el).addClass('show');
  $(el).find('> .dropdown-menu').addClass('show');
  $('#primary-menu').addClass('showing-grandchildren');
}
 */

function mobileNavToggle() {
    if ($('#primary-menu').hasClass('active')) {
        closeMenu();
    } else {
        openMenu();
    }
}

function mobileNavInit() {
    if ($('#primary-menu')) {
        $icons.on('click', () => {
            mobileNavToggle();
        });

        // open menu by pressing return
        $icons.keydown((event) => {
            if (event.keyCode === 13) {
                mobileNavToggle();
            }
        });

        // close mobile nav by pressing escape
        $(document).keyup((event) => {
            if (event.keyCode === 27 && $('#primary-menu').hasClass('active')) {
                closeMenu();
            }
        });
    }
}

jQuery(document).ready(() => {
    mobileNavInit();
});
